import React, { useState } from 'react';
import { Tooltip } from '@lk-gtcom/ecomlab-components';
import "./ButtonCopy.scss";

interface ButtonCopyProps {
  value: string;
  icon?: string;
  style?: React.CSSProperties;
  top?: string | number;
}

const ButtonCopy: React.FC<ButtonCopyProps> = ({
  value,
  icon,
  style = {},
  top
}) => {
  const [currentText, setCurrentText] = useState<string>('Скопировать');

  const handleCopy = () => {
    navigator.clipboard.writeText(value)
      .then(() => {
        setCurrentText('Cкопировано');
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
        setCurrentText('Ошибка');
      });
  };

  const handleBlur = () => {
    setCurrentText('Скопировать');
  };

  const buttonStyle = {
    backgroundImage: icon ? `url(${icon})` : '',
    ...style
  };

  return (
    <Tooltip
      child={
        <button
          className='btn-copy'
          onBlur={handleBlur}
          onClick={handleCopy}
          style={buttonStyle}
          aria-label="Copy to clipboard"
        />
      }
      text={currentText}
      maxWidth={100}
    />
  );
};

export { ButtonCopy }